// extracted by mini-css-extract-plugin
module.exports = {"googleLogin":"LoginWithGoogle_googleLogin__3w9HH","providerLabel":"LoginWithGoogle_providerLabel__3T4VZ"};